import BaseModel from '../core/BaseModel'
import SettingUnitModel from './SettingUnitModel'
export default class ViewOrganizationModel extends BaseModel {
    constructor() {
        super({ 
                name: "view_organization",
                tableName: 'view_organization',
                display_key: 'name'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            name: { 
                name: 'name', 
                type: "String", 
                label: 'Tên đơn vị',
                width: 15,
                filter: { type: 'input',match: 'custom'},
                sortable: true
            },

            tax_number: { 
                name: 'tax_number', 
                type: "String", 
                label: 'Mã số thuế',
                width: 15,
                filter: { type: 'input',match: 'custom'}
            },

            phone_number: { 
                name: 'phone_number', 
                type: "String", 
                label: 'Số điện thoại',
                width: 15,
                filter: { type: 'input',match: 'custom'},
                computed: (data) => {
                    var phoneConvert = (data.phone_number !== undefined && data.phone_number !== null) ? data.phone_number  :  '';
                    if (phoneConvert != '') data.phone_number = phoneConvert.replace('+84', '0');
                }
            },

            email: { 
                name: 'email', 
                type: "String", 
                label: 'Email',
                sortable: true,
                width: 15,
                filter: { type: 'input',match: 'custom'},
            },

            address_full: { 
                name: 'address_full', 
                type: "String", 
                label: 'Địa chỉ',
                width: 15,
                filter: { type: 'input',match: 'custom'},
                computed: (data) => {
                    var str_address = (data.address != undefined ? data.address : '');
                    
                    var wards_name = (data.wards != undefined && data.wards != null ? data.wards.name: '');
                    if (wards_name.length > 0) str_address += (str_address.length > 0 ? ', ' : '') + wards_name;
                    
                    var districts_name = (data.districts != undefined && data.districts != null ? data.districts.name: '');
                    if (districts_name.length > 0) str_address += ', ' + districts_name;
                    
                    var provinces_name = (data.provinces != undefined && data.provinces != null ? data.provinces.name: '');
                    if (provinces_name.length > 0) str_address += ', ' + provinces_name;
                    data.address_full = str_address;
                }
            },
            parent_name: { 
                name: 'parent_name', 
                type: "String", 
                label: 'Tên đơn vị cấp cha',
                filter: { type: 'input',match: 'custom'},
                width: 15,
                sortable: true,
                computed: (data) => {
                    data.parent_name = (data.organization_parent != undefined && data.organization_parent != null) ? data.organization_parent.name: '';
                }
            },
            setting_unit: {
                name: 'setting_unit', label: 'Loại đơn vị', type: "Selection", class: 'left',  dataType: 'Label', dataDisplay: 'name',  width: 10, disabled: true,
                filter: { type: 'select',  display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                sortable: true,
                params: {select: 'id, name', variables: {status: {'_in': [1]}}},
                models: new SettingUnitModel(),
                computed: (data) => {
                    data.setting_unit = (data.setting_unit != undefined && data.setting_unit != null) ? data.setting_unit.id : 0;
                }
            },

            number_accounts: {
                name: 'number_of_accounts', label: 'Số lượng tài khoản', type: "String", class: 'center padding-content',  width: 8,
                callback: true,
                computed: (data) => {
                    var count = (data.organization_account_aggregate !== undefined && data.organization_account_aggregate !== null && data.organization_account_aggregate.aggregate != undefined && data.organization_account_aggregate.aggregate != null) ? data.organization_account_aggregate.aggregate.count  : 0;
                    var numberAccounts = count + "/" + (data.number_of_accounts != undefined ? data.number_of_accounts : 0) ;
                    data.number_accounts = '<abbr class="external-link">' + numberAccounts + '<span class="pi pi-external-link"></span></abbr>';
                }
            },
            status: {
                name: 'status', label: 'Trạng thái hoạt động', type: "Selection",  dataType: 'Label',  class: 'center', width: 10,
                options: [{ value: 1, label: 'Đang hoạt động'}, { value: 0, label: 'Ngưng hoạt động'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' }
            },
            list_activation: {
                name: 'list_activation', type: 'String', label: 'Danh sách kích hoạt', class: 'center', width: 8,
                callback: true,
                computed: (data) => {
                    data.list_activation = '<abbr class="external-link black-color bold"><span class="pi pi-external-link"></span></abbr>';
                }
            },
            list_warranty: {
                name: 'list_warranty', type: 'String', label: 'Danh sách bảo hành', class: 'center', width: 8,
                callback: true,
                computed: (data) => {
                    data.list_warranty = '<abbr class="external-link black-color bold"><span class="pi pi-external-link"></span></abbr>';
                }
            },
            unit_id: {
                refs: 'number_of_subunits organization_type longitude latitude parent_id organization_parent { name } setting_unit { id name }  phone_number unit_id province_id district_id ward_id organization_account_aggregate(where: {user: {status: {_eq: 1}, is_enabled: {_eq: true}}}) { aggregate { count } } wards { name } provinces { name } districts { name } address number_of_accounts',
                display: false
            },
            fied_detail: {
                refs: ' receive_repair_requests ',
                display: false
            },
        },)
    }

}